import React, { useState } from "react";
import {
  FaEnvelope,
  FaIdCard,
  FaMapMarkerAlt,
  FaUserGraduate,
  FaUser,
  FaCalendar,
  FaTint,
  FaMapPin,
  FaGlobe,
  FaBirthdayCake,
  FaDownload,
} from "react-icons/fa";

const ResponsiveTable = ({ json }) => {
  const [jsonData, setJsonData] = useState({
    ...json,
    email: json?.primary_member_id?.email,
    date_of_birth: [
      json?.birth_day,
      json?.birth_month,
      json?.birth_year
    ].filter(Boolean).join("/"),
  });

  const selectedKeys = [
    "primary_member",
    "email",
    "gender",
    "social_security_number",
    "date_of_birth",
    "blood_group",
    "address",
    "area",
    "zipcode",
    "city",
    "state",
    "country",
    "birth_place",
    "qualification",
    "certificate_upload",
  ];

  const getIcon = (key) => {
    const iconMap = {
      primary_member: FaUser,
      email: FaEnvelope,
      aadhar_card: FaIdCard,
      date_of_birth: FaCalendar,
      blood_group: FaTint,
      address: FaMapMarkerAlt,
      pin_code: FaMapPin,
      city: FaMapMarkerAlt,
      state: FaMapMarkerAlt,
      country: FaGlobe,
      birth_place: FaBirthdayCake,
      qualification: FaUserGraduate,
    };
    const IconComponent = iconMap[key] || FaGlobe;
    return <IconComponent className="mr-2 text-blue-500" />;
  };

  const renderTableCell = (key) => (
    <div key={key} className="pb-2 mb-4 border-b">
      <div className="flex items-center mb-1 text-sm font-medium text-gray-600">
        {getIcon(key)}
        <span className="capitalize">{key.replace(/_/g, " ")}</span>
      </div>
      <div className="pl-6 text-sm text-gray-900">
        {key === "certificate_upload" && jsonData[key] ? (
          <a
            href={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${jsonData[key]}`}
            className="inline-flex items-center px-3 py-1 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaDownload className="mr-1" />
            Download
          </a>
        ) : (
          jsonData[key]?.toString() || "N/A"
        )}
      </div>
    </div>
  );

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {selectedKeys.map(renderTableCell)}
    </div>
  );
};

export default ResponsiveTable;
